import _ from "lodash";

export default function extractValues(item, fields) {
  if (!item || !fields || !Array.isArray(fields)) return item;

  const result = _.cloneDeep(item);

  const processField = (data, pathSegments) => {
    const [currentSegment, ...restSegments] = pathSegments;

    if (!data) return;

    const target = _.get(data, currentSegment);

    if (Array.isArray(target)) {
      // اگر مقدار آرایه باشد
      const processedArray = target.map((entry) => {
        if (restSegments.length > 0) {
          processField(entry, restSegments); // ادامه پردازش مسیر برای عناصر آرایه
          return entry;
        } else if (entry?.value !== undefined) {
          // آخرین سطح: مقدار value را استخراج کن
          return entry.value;
        }
        return entry;
      });

      _.set(data, currentSegment, processedArray);
    } else if (typeof target === "object" && target !== null) {
      // اگر مقدار شیء باشد

      if (restSegments.length > 0) {
        processField(target, restSegments); // ادامه پردازش مسیر
      } else if (target?.value !== undefined) {
        _.set(data, currentSegment, target.value); // مقدار value را استخراج کن
      }
    }
  };

  fields.forEach((field) => {
    const pathSegments = field.split(".");
    processField(result, pathSegments);
  });

  return result;
}
